import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { ProtectedRoute, PaidRoute, AdminRoute, AuthOnlyRoute } from "@/components/ProtectedRoute";

import Auth from "@/pages/Auth";
import ResetPassword from "@/pages/ResetPassword";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Onboarding from "@/pages/Onboarding";
import Subscribe from "@/pages/Subscribe";
import SubscribeSuccess from "@/pages/SubscribeSuccess";
import Dashboard from "@/pages/Dashboard";
import Workouts from "@/pages/Workouts";
import WorkoutDetail from "@/pages/WorkoutDetail";
import Programs from "@/pages/Programs";
import ProgramDetail from "@/pages/ProgramDetail";
import Timers from "@/pages/Timers";
import Running from "@/pages/Running";
import RunWorkouts from "@/pages/RunWorkouts";
import RunWorkoutDetail from "@/pages/RunWorkoutDetail";
import GuidedRun from "@/pages/GuidedRun";
import SavedRun from "@/pages/SavedRun";
import Exercises from "@/pages/Exercises";
import ExerciseDetail from "@/pages/ExerciseDetail";
import Coach from "@/pages/Coach";
import Coaching from "@/pages/Coaching";
import Nutrition from "@/pages/Nutrition";
import NutritionArticle from "@/pages/NutritionArticle";
import Community from "@/pages/Community";
import Goals from "@/pages/Goals";
import Progress from "@/pages/Progress";
import Profile from "@/pages/Profile";
import Support from "@/pages/Support";
import Admin from "@/pages/Admin";

function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="dark" enableSystem={false} disableTransitionOnChange storageKey="rdf-theme">
      <div className="App min-h-screen bg-background text-foreground">
        <ErrorBoundary>
          <AuthProvider>
            <BrowserRouter>
            <Routes>
              <Route path="/auth" element={<Auth />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/onboarding" element={<AuthOnlyRoute><Onboarding /></AuthOnlyRoute>} />
              <Route path="/subscribe" element={<ProtectedRoute><Subscribe /></ProtectedRoute>} />
              <Route path="/subscribe/success" element={<ProtectedRoute><SubscribeSuccess /></ProtectedRoute>} />

              <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/workouts" element={<ProtectedRoute><Workouts /></ProtectedRoute>} />
              <Route path="/workouts/:id" element={<ProtectedRoute><WorkoutDetail /></ProtectedRoute>} />
              <Route path="/programs" element={<PaidRoute><Programs /></PaidRoute>} />
              <Route path="/programs/:id" element={<PaidRoute><ProgramDetail /></PaidRoute>} />
              <Route path="/timers" element={<ProtectedRoute><Timers /></ProtectedRoute>} />
              <Route path="/running" element={<ProtectedRoute><Running /></ProtectedRoute>} />
              <Route path="/run-workouts" element={<PaidRoute><RunWorkouts /></PaidRoute>} />
              <Route path="/run-workouts/:id" element={<PaidRoute><RunWorkoutDetail /></PaidRoute>} />
              <Route path="/run-workouts/:id/guided" element={<PaidRoute><GuidedRun /></PaidRoute>} />
              <Route path="/runs/:id" element={<ProtectedRoute><SavedRun /></ProtectedRoute>} />
              <Route path="/exercises" element={<ProtectedRoute><Exercises /></ProtectedRoute>} />
              <Route path="/exercises/:id" element={<ProtectedRoute><ExerciseDetail /></ProtectedRoute>} />
              <Route path="/coach" element={<PaidRoute><Coach /></PaidRoute>} />
              <Route path="/coaching" element={<ProtectedRoute><Coaching /></ProtectedRoute>} />
              <Route path="/nutrition" element={<PaidRoute><Nutrition /></PaidRoute>} />
              <Route path="/nutrition/:id" element={<PaidRoute><NutritionArticle /></PaidRoute>} />
              <Route path="/community" element={<ProtectedRoute><Community /></ProtectedRoute>} />
              <Route path="/goals" element={<ProtectedRoute><Goals /></ProtectedRoute>} />
              <Route path="/progress" element={<ProtectedRoute><Progress /></ProtectedRoute>} />
              <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
              <Route path="/support" element={<ProtectedRoute><Support /></ProtectedRoute>} />
              <Route path="/admin" element={<AdminRoute><Admin /></AdminRoute>} />

              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
            <Toaster position="top-center" />
          </BrowserRouter>
        </AuthProvider>
        </ErrorBoundary>
      </div>
    </ThemeProvider>
  );
}

export default App;
